export enum UserStatuses
{
    Invited = '01hbg1qamx1t5wjkbds1vtbg5c',
    Active = '01hbg1qamx1t5wjkbds1vtbg5d',
    Inactive = '01hbg1qamx1t5wjkbds1vtbg5e',
}
